import Head from 'next/head';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useCategories } from '@/hooks/useCategories';
import { Header } from '@/components/Header/Header';
import { Footer } from '../Footer/Footer';
import styles from './MclLayout.module.scss';

interface ILayoutProps {
  children?: React.ReactNode;
}

export const ContentPageLayout = ({ children }: ILayoutProps) => {
  const { t } = useTranslation();
  const { categories } = useCategories();

  return (
    <div className={styles.mclLayout}>
      <Head>
        <title>{t('common:mijn-carellurvink.page-title')}</title>
      </Head>

      <div className={styles.header}>
        <Header categories={categories} />
      </div>

      <main className={styles.main}>{children}</main>
      <div className={styles.footer}>
        <Footer />
      </div>
    </div>
  );
};
